import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { ApolloProvider } from 'react-apollo';

// TODO: add tests later
function withBridge(Component) {
  return function (_ref) {
    var client = _ref.client,
        props = _objectWithoutProperties(_ref, ["client"]);

    return /*#__PURE__*/React.createElement(ApolloProvider, {
      client: client
    }, /*#__PURE__*/React.createElement(Component, props));
  };
}

export { withBridge };